<template>
    <div>
        <el-row>
            <template v-for="(item) in btns">
                <el-button v-if="item.method" :type="item.type" :icon="item.icon" @click="doBtn(item.method)" :key="item.buttonId" size="medium">
                    {{ item.buttonName }}
                </el-button>
            </template>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: 'btnGroup',
        props: ['btns'],
        data() {
            return {

            }
        },
        methods: {
            doBtn(type) {
                this.$emit('doBtn', type)
            },
        }
    }
</script>

<style scoped>
    /deep/ .el-button--primary {
        color: #fff;
        background-color: #409eff;
        border-color: #409eff;
    }

    /deep/ .el-button--primary:hover {
        background-color: #66b1ff;
        border-color: #66b1ff;
    }
</style>
